import clx from 'classnames';
import { HTMLAttributes } from 'react';

const FieldLayout = ({ children, className }: HTMLAttributes<HTMLBaseElement>) => (
  <div className={clx('flex flex-col gap-y-1.5 w-full', className)}>{children}</div>
);

export default FieldLayout;
